const Profile = ({ style }) => {
  return (
    <svg
      style={style}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6784 2.4707C9.21237 2.4707 7.20752 4.47555 7.20752 6.94161C7.20752 9.3606 9.09942 11.3184 11.5655 11.4031C11.6408 11.3937 11.7161 11.3937 11.7725 11.4031C11.7914 11.4031 11.8008 11.4031 11.8196 11.4031C11.829 11.4031 11.829 11.4031 11.8384 11.4031C14.248 11.3184 16.1399 9.3606 16.1493 6.94161C16.1493 4.47555 14.1445 2.4707 11.6784 2.4707Z"
        fill="#40E5A0"
      />
      <path
        d="M16.4596 13.9165C13.8336 12.1658 9.5509 12.1658 6.90601 13.9165C5.71063 14.7072 5.05176 15.7896 5.05176 16.9474C5.05176 18.1051 5.71063 19.1781 6.89659 19.9687C8.21433 20.8535 9.94622 21.2959 11.6781 21.2959C13.41 21.2959 15.1419 20.8535 16.4596 19.9687C17.6456 19.1687 18.3045 18.0957 18.3045 16.9285C18.295 15.7802 17.6456 14.6978 16.4596 13.9165ZM13.8712 16.1755L11.4993 18.5475C11.3863 18.6604 11.2357 18.7169 11.0851 18.7169C10.9345 18.7169 10.7839 18.651 10.671 18.5475L9.48501 17.3615C9.25911 17.1356 9.25911 16.7591 9.48501 16.5332C9.71091 16.3073 10.0874 16.3073 10.3133 16.5332L11.0851 17.305L13.0429 15.3472C13.2688 15.1213 13.6453 15.1213 13.8712 15.3472C14.1065 15.5731 14.1065 15.9496 13.8712 16.1755Z"
        fill="#40E5A0"
      />
    </svg>
  );
};

export default Profile;
